import React from "react";

const GovermentCertified = () => {
  return <div>GovermentCertified</div>;
};

export default GovermentCertified;
